module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagebar"
  }, [_c('ul', {
    staticClass: "mypager",
    class: _vm.alignCls
  }, [_c('li', [_c('a', {
    staticClass: "pg__prev",
    class: {
      disabled: _vm.currentPage === 1
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('span', [_vm._v("«")])])]), _vm._v(" "), _vm._l((_vm.pageList), function(item) {
    return _c('li', {
      key: item
    }, [(item) ? _c('a', {
      class: {
        active: item === _vm.currentPage
      },
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.pageOffset(item)
        }
      }
    }, [_vm._v(_vm._s(item))]) : _c('span', {
      staticClass: "ellipse"
    }, [_vm._v("...")])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pg__next",
    class: {
      disabled: _vm.currentPage === _vm.pageCount || _vm.count === 0
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('span', [_vm._v("»")])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3df4ed84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/combo/pagination.vue
// module id = 595
// module chunks = 1